// Aboutgulf.js
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from "prop-types";
import useOnScreen from './Useonscreen';

function Aboutgulf({ title, description }) {
  const ref = useRef();
  const imgRef = useRef(); 
  const [isOnScreen, setIsOnScreen] = useState(false);
  const [isScreenImg, setIsScreenImg] = useState(false); 

  const isnScreenImg = useOnScreen(imgRef); 

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsOnScreen(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  useEffect(() => {
    setIsScreenImg(isnScreenImg);
  }, [isnScreenImg]);

  return (
    <section className="bg-gray-100" ref={ref}>
      <div className="grid max-w-screen-xl px-4 pt-14 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-10 lg:grid-cols-12">
        <div className={`mr-auto place-self-center lg:col-span-7
            ${isOnScreen ? 'animate-slideInLeft' : 'opacity-0'}
          `}>
          <h1
            className="text-6xl sm:text-7xl md:text-8xl font-bebas-neue text-custom-purple font-bold uppercase max-w-2xl mb-4 leading-none tracking-tight"       
          >
            {title}
          </h1>
          <p className="max-w-2xl mb-6 font-light lg:mb-8 md:text-lg lg:text-xl text-gray-400">
            {description}
          </p>
        </div>
        <div className={`lg:mt-0 md:-my-14 sm:-my-9 lg:col-span-5 lg:flex
                      ${isScreenImg ? 'animate-spinnerGrow' : 'opacity-0'}
          `}>
          <img 
            ref={imgRef} 
            src="/assets/managment.png" 
            alt="mockup" 
          />
        </div>
      </div>
    </section>
  );
}

Aboutgulf.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Aboutgulf;
